import { render, staticRenderFns } from "./WorkerCard.vue?vue&type=template&id=06688868"
import script from "./WorkerCard.vue?vue&type=script&lang=ts"
export * from "./WorkerCard.vue?vue&type=script&lang=ts"
import style0 from "./WorkerCard.vue?vue&type=style&index=0&id=06688868&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports